import React, { useState, useEffect } from 'react';

import axios from 'axios';


import LoadingButton from 'components/Shared/LoadingButton';




type Props = {
    litigeId: number,
    factureFacultative: boolean
}

export default function RelancerCreationDossier({ litigeId, factureFacultative } : Props) {


    const [retrying, setRetrying] = useState(false);

    // Relance
    useEffect(() => {

        const retry = () => {

            axios.post(`api/litiges/${litigeId}/relancer-creation-dossier`, {factureFacultative})

                .catch(function (error) {
                    console.log(error);
                })
                .then(function () {
                    // always executed
                    setRetrying(false);
                });
        };

        if (retrying) {
            retry();
        }

    }, [litigeId, retrying]);
    

    return (
        <LoadingButton
            onClick={() => setRetrying(true)}
            label={factureFacultative ? "Créer dossier sans facture" : "Créer dossier"}
            pending={retrying}
            color={factureFacultative ? "primary" : "secondary"}
            disabled={false}
            icon={null}
            mode={""}
            style={{}}
            tooltip={""}
        />      
    );
}
